<template>
  <div>
    <el-dialog
      title="选择组或者群"
      width="740px"
      :visible.sync="viewVisible"
      :before-close="handleClose"
      append-to-body
    >
      <div class="select-box" v-loading="uploadLoading">
        <div class="left">
          <div class="search">
            <img src="@/assets/images/icon/search.png" alt="" />
            <el-input
              placeholder="请输入群名称"
              v-model="filterContent"
              style="width: 280px"
            ></el-input>
            <span class="update" @click="handleUpdate">刷新</span>
          </div>
          <div class="tree-box">
            <el-tree
              class="filter-tree"
              :data="treeData"
              show-checkbox
              :props="defaultProps"
              default-expand-all
              @check-change="handleChange"
              node-key="id"
              :filter-node-method="filterNode"
              ref="tree"
            >
            </el-tree>
          </div>
        </div>
        <div class="right">
          <div class="select-people">
            <div>
              <span class="text">已选择</span>
              <span class="num">（{{ selectData.length }}）</span>
            </div>
            <div class="clearAll" @click="clearAll">全部清空</div>
          </div>
          <div class="list">
            <div class="item" v-for="(item, index) in selectData" :key="index">
              <span
                ><img
                  class="group"
                  src="@/assets/images/icon/member.png"
                  alt=""
                />{{ item.groupName }}</span
              >
              <div class="close" @click="delNode(item, index)"></div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGroupList, syncGroup } from "@/api/marketing/dongdong";
export default {
  name: "",
  data() {
    return {
      // visible: true,
      filterContent: "",
      defaultProps: {
        children: "subGroups",
        label: "groupName",
      },
      selectData: [],
      treeData: [
        // {
        //   id: 1,
        //   label: "一级 1",
        //   children: [
        //     {
        //       id: 4,
        //       label: "二级 1-1",
        //     },
        //   ],
        // },
      ],
      loading: false,
      tempData: [],
      uploadLoading: false,
    };
  },
  props: {
    groupData: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    filterContent(val) {
      this.$refs.tree.filter(val);
    },
    visible(val) {
      if (val) {
        this.selectData = JSON.parse(JSON.stringify(this.groupData));
        if (this.treeData && this.treeData.length > 0) {
          this.$nextTick(() => {
            this.$refs.tree.setCheckedNodes(this.selectData);
          });
        }
      }
    },
  },

  computed: {
    viewVisible: {
      get: function () {
        return this.visible;
      },
      set: function (newValue) {
        if (newValue) {
          console.log("set-", newValue);
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
  },
  mounted() {
    this.selectData = JSON.parse(JSON.stringify(this.groupData));
    console.log('this.selectData', this.selectData)
    this.getDataList();
  },
  methods: {
    handleUpdate() {
      // 刷新
      this.uploadLoading = true;
      syncGroup().then((res) => {
        console.log(res);
        if (res.code == "1") {
          this.getDataList();
        }else {
          this.$message.error(res.message)
          this.uploadLoading = false;
        }
      }).catch((err) => {
        this.uploadLoading = false;
      });
    },
    clearAll() {
      this.selectData = [];
      this.$refs.tree.setCheckedNodes(this.selectData);
    },
    handleChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate)
      if (data.subGroups) {
        return
      }
      if (checked) {
        var findObj = this.selectData.findIndex((item, index, arr) => {
          return item.id == data.id
        })
        if (findObj === -1) {
          this.selectData.push(data)
        }
      } else {
        this.selectData = this.selectData.filter((item) => {
          return item.id != data.id
        })
      }

      // var dataList = this.$refs.tree.getCheckedNodes();
      // var filterData = dataList.filter((item) => {
      //   return !item.subGroups;
      // });
      // this.selectData = filterData;
    },
    getDataList() {
      this.tempData = JSON.parse(JSON.stringify(this.selectData));
      getGroupList().then((res) => {
        if (res.code === 1) {
          this.treeData = res.data;
          if (this.visible) {
            this.$nextTick(() => {
              this.selectData = this.tempData;
              this.$refs.tree.setCheckedNodes(this.selectData);
              if (this.uploadLoading) {
                this.$message.success("刷新成功！");
              }
              this.uploadLoading = false;
            });
            
          }else{
            this.uploadLoading = false;
          }
        }else {
          this.uploadLoading = false;
          this.$message.error(res.message)
        }
      });
    },
    delNode(item, index) {
      this.selectData.splice(index, 1);
      this.$refs.tree.setCheckedNodes(this.selectData);
    },

    handleClose() {
      this.viewVisible = false;
      // this.visible = false;
    },
    handleConfirm() {
      this.viewVisible = false;
      this.$emit("on-confirm", this.selectData);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.groupName.indexOf(value) !== -1;
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-dialog__footer {
  border-top: 1px solid #f6f6f6;
  padding-bottom: 30px;
  padding-right: 30px;
  .dialog-footer {
    text-align: right;
  }
}
/deep/.tree-box {
  color: #333 !important;
}
/deep/.el-dialog__body {
  padding: 20px 20px 0 30px;
}
/deep/.el-dialog .el-dialog__header {
  line-height: 54px;
  height: 54px;
  padding-left: 30px;
}
.select-box {
  display: flex;
  flex-direction: row;
  .left {
    width: 330px;
    // padding-right: 20px;
    // padding-top: 20px;
    box-sizing: border-box;
    // border-right: 1px solid #f6f6f6;
  }
  .search {
    position: relative;
    .update {
      color: #fe4d45;
      margin-left: 20px;
      cursor: pointer;
      font-size: 14px;
    }
    img {
      position: absolute;
      width: 16px;
      top: 8px;
      left: 10px;
      z-index: 9;
      color: #c5c7cb;
      font-size: 16px;
    }
    .el-input {
      /deep/input {
        border: 1px solid #dcdfe6;
        border-radius: 3px !important;
        padding-left: 36px !important;
      }
    }
  }
  .tree-box {
    margin-top: 20px;
    height: 430px;
    overflow: auto;
  }
  .right {
    flex: 1;
    padding-left: 40px;
    // padding-top: 8px;
    .select-people {
      padding-right: 10px;
      font-size: 14px;
      // color: #999;
      font-weight: 400;
      color: #fe4d45;
      line-height: 32px;
      .text {
        color: #333;
        font-weight: 500;
      }
      .num {
        font-weight: 500;
      }
      .clearAll {
        cursor: pointer;
      }
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .list {
      margin-top: 20px;
      max-height: 440px;
      overflow: auto;
      padding-right: 10px;
      .item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 10px;
        font-size: 14px;
        .group {
          width: 12px;
          margin-right: 4px;
        }
        i {
          margin-right: 4px;
        }
      }
    }
  }
}
.close {
  // display: none;
  // position: absolute;
  // right: -6px;
  // top: -6px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  cursor: pointer;
  background-color: #fe4d45;
  // display: none;
  position: relative;
  &:before,
  &:after {
    position: absolute;
    top: 4px;
    left: 7px;
    content: " ";
    height: 8px;
    width: 2px;
    background-color: #fff;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
}
</style>